import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  InputAdornment,
  IconButton,
  CircularProgress,
  Typography
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";

const WhatsappGroupsModal = ({ open, onClose, whatsappId }) => {
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [searchParam, setSearchParam] = useState("");

  useEffect(() => {
    if (!open || !whatsappId) return;

    const fetchGroups = async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/whatsapp/${whatsappId}/groups`);
        setGroups(data.groups || []);
      } catch (err) {
        toastError(err);
      }
      setLoading(false);
    };

    fetchGroups();
  }, [open, whatsappId]);

  const handleClose = () => {
    setSearchParam("");
    setGroups([]);
    onClose();
  };

  const handleCopyId = id => {
    navigator.clipboard.writeText(id.replace("@g.us", ""));
    toast.success(i18n.t("whatsappGroupsModal.copied"));
  };

  const filteredGroups = groups.filter(group =>
    group.name?.toLowerCase().includes(searchParam.toLowerCase())
  );

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth scroll="paper">
      <DialogTitle>{i18n.t("whatsappGroupsModal.title")}</DialogTitle>
      <DialogContent dividers>
        <TextField
          placeholder={i18n.t("contacts.searchPlaceholder")}
          type="search"
          fullWidth
          value={searchParam}
          onChange={e => setSearchParam(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon style={{ color: "gray" }} />
              </InputAdornment>
            )
          }}
          style={{ marginBottom: 16 }}
        />

        {loading ? (
          <CircularProgress size={24} />
        ) : filteredGroups.length === 0 ? (
          <Typography variant="body2" color="textSecondary">
            {i18n.t("whatsappGroupsModal.empty")}
          </Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>{i18n.t("whatsappGroupsModal.table.name")}</TableCell>
                <TableCell align="center">
                  {i18n.t("whatsappGroupsModal.table.participants")}
                </TableCell>
                <TableCell align="center">{i18n.t("whatsappGroupsModal.table.id")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredGroups.map(group => (
                <TableRow key={group.id}>
                  <TableCell>{group.name}</TableCell>
                  <TableCell align="center">{group.participantsCount}</TableCell>
                  <TableCell align="center">
                    <IconButton size="small" onClick={() => handleCopyId(group.id)}>
                      <FileCopyOutlinedIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" variant="outlined">
          {i18n.t("whatsappGroupsModal.buttons.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WhatsappGroupsModal;
